var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"login-with-google-btn",attrs:{"href":"/google/login"}},[_vm._v("Über Google anmelden")])])}]

export { render, staticRenderFns }